import { render, staticRenderFns } from "./ForgetPassword.vue?vue&type=template&id=a75c5a84&scoped=true&"
import script from "./ForgetPassword.vue?vue&type=script&lang=js&"
export * from "./ForgetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgetPassword.vue?vue&type=style&index=0&id=a75c5a84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a75c5a84",
  null
  
)

export default component.exports